export default __webpack_public_path__ + "static/media/hillside.7a2fc369.png";